var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classname,attrs:{"id":_vm.element}})
}
var staticRenderFns = []

export { render, staticRenderFns }